import axios from "axios";

export default axios.create({
  baseURL: "https://api.intellitraffic.info/php/",  // Change to your subdomain
  withCredentials: true,
});
  